module.exports = __webpack_public_path__ + "static/img/card_3_11.bcb879b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/card_3_11.png
// module id = cMto
// module chunks = 0